import { useTranslation } from "react-i18next";
const ModelPicture = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="main__content display_v1" id="main__content__v1">
        <div className="item2">
          <div id="model__create_picture_photo">
            <div>
              <img
                id="img__model_create_picture"
                src="/assets/images/model2.svg"
              />
            </div>
          </div>
        </div>
        <div className="item4">
          <div id="model__create_picture_content">
            <div className=" text__content">
              <div className="tc__">
                <p>{t("model__picture_content_1")}</p>
                <span className="rainbow__text_t2 num">20</span>
                <span style={{ fontSize: "40px", fontWeight: "bold" }}>
                  {t("model__picture_content_2")}
                </span>
                <p>{t("model__picture_content_3")}</p>
              </div>
              <div className="tc__content">
                <p>
                  {t("model__picture_content_4")}{" "}
                  <strong>{t("model__picture_content_5")}</strong>
                  {t("model__picture_content_6")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="main__content display_v2" id="main__content__v1">
        <div className="item2">
          <div id="model__create_picture_photo">
            <div className=" text__content">
              <div className="tc__">
                <p>{t("model__picture_content_1")}</p>
                <span className="rainbow__text_t2 num">20</span>
                <span>{t("model__picture_content_2")}</span>
                <p>{t("model__picture_content_3")}</p>
              </div>
            </div>
            <div>
              <img
                id="img__model_create_picture"
                src="/assets/images/model2.svg"
              />
            </div>
          </div>
        </div>
        <div className="item4">
          <div id="model__create_picture_content">
            <div className=" text__content">
              <div className="tc__content_v2">
                <p>
                  {t("model__picture_content_4")}{" "}
                  <strong>{t("model__picture_content_5")}</strong>
                  {t("model__picture_content_6")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ModelPicture;
